/*
  Keeps the "(You save …)" caption and the strikethrough in step with the
  subscription widget.

  snippets/price.liquid renders both from the one-time price. Joy rewrites the
  sale price in place when a plan is selected but leaves the other two alone,
  so on a 6 BOX the caption kept saying "(You save $12.00)" against a $54.00
  price, and the strikethrough dropped from the $72.00 RRP to the $60.00
  one-time price.

  snippets/product-price.liquid publishes a caption per price — the one-time
  one and every selling plan's. This matches on whatever price is currently
  displayed, so it follows the widget without needing to know anything about it.
*/
(function () {
  const DATA_SELECTOR = 'script[data-you-save-plans]';
  const AMOUNT = /\d[\d.,]*/;

  function readPlans(container) {
    const source = container.querySelector(DATA_SELECTOR);
    if (!source) return null;
    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      return null;
    }
  }

  function displayedAmount(container) {
    const sale = container.querySelector('.price-item--sale');
    const match = sale && sale.textContent.match(AMOUNT);
    return match ? match[0] : '';
  }

  // Every write is guarded on the value actually differing, so the observer
  // below settles after a single pass instead of retriggering itself.
  function setText(element, value) {
    if (!element || !value) return;
    if (element.textContent.trim() !== value.trim()) element.textContent = value;
  }

  // Swaps just the number, leaving whatever currency prefix the storefront's
  // own formatting applied — Liquid renders "$72.00", the market formatter
  // rewrites it to "A$72.00", and overwriting wholesale would drop the "A".
  function setAmount(element, amount) {
    if (!element || !amount) return;
    const current = element.textContent.trim();
    if (!AMOUNT.test(current)) return;
    const next = current.replace(AMOUNT, amount);
    if (current !== next) element.textContent = next;
  }

  function apply(container) {
    const data = readPlans(container);
    if (!data || !data.captions) return;

    // Only speak for prices we published a figure for. Anything else on screen
    // came from somewhere we don't model, and a wrong saving beats no update.
    setText(container.querySelector('.price__caption'), data.captions[displayedAmount(container)]);
    setAmount(container.querySelector('.price__sale s.price-item--regular'), data.compareAmount);
  }

  function watch(container) {
    if (container.dataset.youSaveWatched) return;
    container.dataset.youSaveWatched = 'true';

    let queued = false;
    const observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        apply(container);
      });
    });

    observer.observe(container, { childList: true, subtree: true, characterData: true });
    apply(container);
  }

  function init() {
    // Anchor on the script tag, which product-price.liquid always renders — the
    // plan data is absent on variants where the price equals the compare-at, and
    // we still need to be watching when the shopper switches to one that has it.
    // The price block is replaced wholesale on variant change, so observe the
    // wrapper that survives it rather than the price element itself.
    document.querySelectorAll('[data-you-save-script]').forEach(function (marker) {
      const container = marker.closest('[id^="Price-"]') || marker.parentElement;
      if (container) watch(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Joy mounts asynchronously and may render after DOMContentLoaded.
  window.addEventListener('load', init);
})();
